const BASE_URL = 'customers'

export default {
  POST_SAVE: `/${BASE_URL}`,
  GET_LIST_CUSTOMERS: BASE_URL,
  GET_CUSTOMER_BY_ID: BASE_URL,
  POST_CUSTOMERS: BASE_URL,
}
